import { gql } from "@apollo/client"
import {
  VerifyStripeAchPaymentMethodInput,
  VerifyStripeAchPaymentMethodPayload,
} from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

export const PAYMENTS_COMPANY_VERIFY_STRIPE_ACH_PAYMENT_METHOD = gql`
  mutation PaymentsCompanyVerifyStripeAchPaymentMethod(
    $paymentMethodId: ID!
    $amount1: Int!
    $amount2: Int!
  ) {
    verifyStripeAchPaymentMethod(
      input: { paymentMethodId: $paymentMethodId, amount1: $amount1, amount2: $amount2 }
    ) {
      paymentMethod {
        ... on PaymentMethodStripeAch {
          id
        }
      }
      errors
    }
  }
`

export const useVerifyStripeAchPaymentMethod = (
  options?: InjectedOptions<
    { verifyStripeAchPaymentMethod: VerifyStripeAchPaymentMethodPayload },
    VerifyStripeAchPaymentMethodInput
  >,
) =>
  useMutation(PAYMENTS_COMPANY_VERIFY_STRIPE_ACH_PAYMENT_METHOD, {
    analyticsEventName: "stripe_ach_method_verified",
    ...options,
  })
